export default __webpack_public_path__ + "static/media/Mark of Deception.974b6acd.jpg";